module.exports = __webpack_public_path__ + "@/assets/img/MA-5000-red.d7876f34.jpg";